/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto } from '../models/Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TradePreClearanceService {

    /**
     * @param id
     * @returns Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTradePreClearancePreClearanceRequest(
        id: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceReqDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/trade-pre-clearance/{id}/pre-clearance-request',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
